(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jersey-fit-indicator"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jersey-fit-indicator')) {
    customElements.define('jersey-fit-indicator', class JerseyFitIndicator extends HTMLElement {
      connectedCallback() {
        this.handleChange = this.handleChange.bind(this);
        document.addEventListener('change', this.handleChange);
        this.update(this.dataset.initialSize);
      }

      disconnectedCallback() {
        document.removeEventListener('change', this.handleChange);
      }

      handleChange(event) {
        const variantRoot = event.target.closest?.(`variant-selects[data-section="${this.dataset.sectionId}"]`);
        if (!variantRoot) return;

        const normalizeControlName = (name) => String(name || '').replace(/\s+/g, '');
        const expectedNames = [
          `options[${this.dataset.sizeOptionName}]`,
          `${this.dataset.sizeOptionName}-${this.dataset.sizeOptionPosition}`
        ].map(normalizeControlName);
        let size = '';
        if (expectedNames.includes(normalizeControlName(event.target.name))) size = event.target.value;

        if (!size) {
          const controls = variantRoot.querySelectorAll('input:checked, select');
          controls.forEach((control) => {
            if (expectedNames.includes(normalizeControlName(control.name))) size = control.value;
          });
        }

        if (size) this.update(size);

      }

      normalizeSize(value) {
        const normalized = String(value || '')
          .toUpperCase()
          .replace(/^ADULT\s*SIZE\s*/, '')
          .replace(/\s+/g, '')
          .replace(/-/g, '');

        const aliases = {
          CH: 'S', SMALL: 'S',
          MEDIANA: 'M', MEDIUM: 'M',
          G: 'L', GRANDE: 'L', LARGE: 'L',
          EG: 'XL', EXTRAGRANDE: 'XL',
          XXL: '2XL', '2X': '2XL', '2EG': '2XL',
          XXXL: '3XL', '3X': '3XL', '3EG': '3XL',
          XXXXL: '4XL', '4X': '4XL', '4EG': '4XL'
        };
        if (aliases[normalized]) return aliases[normalized];
        if (/^X{2,}L$/.test(normalized)) return `${normalized.length - 1}XL`;
        if (/^\d+X$/.test(normalized)) return `${normalized.slice(0, -1)}XL`;
        if (/^\d+EG$/.test(normalized)) return `${normalized.slice(0, -2)}XL`;
        return normalized;
      }

      getProfile(size) {
        const fan = {
          S: [42, 'fanNormal'],
          M: [50, 'fanNormal'],
          L: [68, 'fanSlight'],
          XL: [84, 'fanReduced'],
          '2XL': [90, 'fanReduced'],
          '3XL': [96, 'fanExtended'],
          '4XL': [100, 'fanExtended']
        };
        const player = {
          S: [78, 'playerSmall'],
          M: [88, 'playerMid'],
          L: [94, 'playerMid'],
          XL: [100, 'playerLarge'],
          '2XL': [100, 'playerLarge'],
          '3XL': [100, 'playerLarge']
        };
        const woman = {
          S: [72, 'playerSmall'],
          M: [84, 'fanReduced'],
          L: [94, 'playerLarge'],
          XL: [100, 'playerLarge']
        };
        const windbreaker = {
          S: [45, 'fanNormal'],
          M: [55, 'fanNormal'],
          L: [68, 'fanSlight'],
          XL: [85, 'fanReduced'],
          '2XL': [96, 'playerLarge'],
          '3XL': [100, 'playerLarge']
        };
        const tracksuitCasual = {
          S: [10, 'tracksuitCasualS'],
          M: [30, 'tracksuitCasualM'],
          L: [50, 'tracksuitCasualL'],
          XL: [70, 'tracksuitCasualXl'],
          '2XL': [90, 'tracksuitCasualXl']
        };
        const tracksuitTraining = {
          S: [10, 'tracksuitTrainingS'],
          M: [30, 'tracksuitTrainingM'],
          L: [50, 'tracksuitTrainingL'],
          XL: [70, 'tracksuitTrainingXl'],
          '2XL': [90, 'tracksuitTraining2xl']
        };
        const child = {
          16: [4, 'childAge16'],
          18: [14, 'childAge18'],
          20: [23, 'childAge20'],
          22: [41, 'childAge22'],
          24: [50, 'childAge24'],
          26: [68, 'childAge26'],
          28: [91, 'childAge28']
        };
        let profile = fan;
        if (this.dataset.version === 'player') profile = player;
        if (this.dataset.version === 'woman') profile = woman;
        if (this.dataset.version === 'child') profile = child;
        if (this.dataset.version === 'windbreaker') profile = windbreaker;
        if (this.dataset.version === 'tracksuit-casual') profile = tracksuitCasual;
        if (this.dataset.version === 'tracksuit-training') profile = tracksuitTraining;
        if (profile[size]) return profile[size];

        if (this.dataset.version === 'child') {
          const numericSize = Number.parseInt(size, 10);
          if (numericSize < 16) return profile[16];
          if (numericSize > 28) return profile[28];
          return [50, 'fallbackMessage'];
        }

        const orderedSizes = ['S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL', '6XL', '7XL', '8XL', '9XL', '10XL'];
        let highestSize = '4XL';
        if (this.dataset.version === 'woman') highestSize = 'XL';
        if (this.dataset.version === 'player' || this.dataset.version === 'windbreaker') highestSize = '3XL';
        if (this.dataset.version.startsWith('tracksuit')) highestSize = '2XL';
        const selectedRank = orderedSizes.indexOf(size);
        const highestRank = orderedSizes.indexOf(highestSize);
        if (selectedRank > highestRank) return profile[highestSize];

        return [this.dataset.version === 'player' ? 88 : 62, 'fallbackMessage'];
      }

      update(rawSize) {
        const size = this.normalizeSize(rawSize);
        let [position, messageKey] = this.getProfile(size);

        if (this.dataset.version !== 'child' && !this.dataset.version.startsWith('tracksuit')) {
          if (this.dataset.adjustment === 'mas-holgado' || this.dataset.adjustment === 'more-relaxed') position -= 15;
          if (this.dataset.adjustment === 'mas-ajustado' || this.dataset.adjustment === 'more-fitted') position += 15;
        }
        position = Math.max(0, Math.min(100, position));

        this.style.setProperty('--fit-position', `${position}%`);
        const message = this.dataset[messageKey] || this.dataset.fallbackMessage;
        this.querySelector('[data-fit-message]').textContent = message;

        if (this.dataset.version === 'child') {
          this.querySelectorAll('[data-child-size]').forEach((step) => {
            step.classList.toggle('is-selected', step.dataset.childSize === size);
          });
          this.querySelector('[data-fit-scale]').setAttribute('aria-label', message);
        } else if (this.dataset.version.startsWith('tracksuit')) {
          this.querySelectorAll('[data-guide-size]').forEach((step) => {
            step.classList.toggle('is-selected', step.dataset.guideSize === size);
          });
          this.querySelector('[data-fit-scale]').setAttribute('aria-label', message);
        } else {
          let fitLabel = this.dataset.labelNormal;
          if (position < 34) fitLabel = this.dataset.labelLoose;
          if (position >= 67) fitLabel = this.dataset.labelTight;
          this.querySelector('[data-fit-scale]').setAttribute('aria-label', `${fitLabel}. ${message}`);
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
